export const APOLLO_CUSTOM_CACHE_KEY = 'apollo-app-cache';

export function resetApolloLocalStorageItems() {
  const storageCache = (window.localStorage.getItem(APOLLO_CUSTOM_CACHE_KEY) || '{}');
  const tmpStorage = JSON.parse(storageCache);
  if (tmpStorage.ROOT_QUERY) {
    tmpStorage.ROOT_QUERY.currentAccount = {};
    tmpStorage.ROOT_QUERY.currentAccountBranch = {};
    tmpStorage.ROOT_QUERY.currentBranch = {};
    tmpStorage.ROOT_QUERY.branches = [];
    tmpStorage.ROOT_QUERY.offerColumnsVisibility = [];
    tmpStorage.ROOT_QUERY.valueTexts = {};
    tmpStorage.ROOT_QUERY.disablePriceCalculation = null;

    window.localStorage.setItem(APOLLO_CUSTOM_CACHE_KEY, JSON.stringify(tmpStorage));
  } else {
    window.localStorage.clear();
  }
}
